/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddProcessOfferElementItemRequestDto } from '../models';
// @ts-ignore
import type { AddProcessOfferElementRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferElementDetailsDto } from '../models';
// @ts-ignore
import type { ProcessOfferElementIdDto } from '../models';
// @ts-ignore
import type { ProcessOfferElementItemCalculationRequestDto } from '../models';
// @ts-ignore
import type { ProcessOfferElementItemCalculationResultDto } from '../models';
// @ts-ignore
import type { ProcessOfferElementItemIdDto } from '../models';
// @ts-ignore
import type { SkipProcessOfferElementRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessOfferElementCommentRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessOfferElementItemRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessOfferElementPredefinedItemsRequestDto } from '../models';
/**
 * RestProcessOfferElementsApi - axios parameter creator
 */
export const RestProcessOfferElementsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary add process offer element
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {AddProcessOfferElementRequestDto} addProcessOfferElementRequestDto Add process offer element request
         * @param {number} [processOfferGroupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProcessOfferElement: async (userId: string, processId: string, processOfferId: string, addProcessOfferElementRequestDto: AddProcessOfferElementRequestDto, processOfferGroupId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addProcessOfferElement', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('addProcessOfferElement', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('addProcessOfferElement', 'processOfferId', processOfferId)
            // verify required parameter 'addProcessOfferElementRequestDto' is not null or undefined
            assertParamExists('addProcessOfferElement', 'addProcessOfferElementRequestDto', addProcessOfferElementRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/elements`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (processOfferGroupId !== undefined) {
                localVarQueryParameter['processOfferGroupId'] = processOfferGroupId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProcessOfferElementRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary add process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {AddProcessOfferElementItemRequestDto} addProcessOfferElementItemRequestDto Add process offer element item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProcessOfferElementItem: async (userId: string, processId: string, processOfferId: string, processOfferElementId: number, addProcessOfferElementItemRequestDto: AddProcessOfferElementItemRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addProcessOfferElementItem', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('addProcessOfferElementItem', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('addProcessOfferElementItem', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferElementId' is not null or undefined
            assertParamExists('addProcessOfferElementItem', 'processOfferElementId', processOfferElementId)
            // verify required parameter 'addProcessOfferElementItemRequestDto' is not null or undefined
            assertParamExists('addProcessOfferElementItem', 'addProcessOfferElementItemRequestDto', addProcessOfferElementItemRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/elements/{processOfferElementId}/items`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferElementId}', encodeURIComponent(String(processOfferElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProcessOfferElementItemRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary calculate process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {number} processOfferElementItemId 
         * @param {ProcessOfferElementItemCalculationRequestDto} processOfferElementItemCalculationRequestDto Process offer element item calculation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateProcessOfferElementItem: async (userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, processOfferElementItemCalculationRequestDto: ProcessOfferElementItemCalculationRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('calculateProcessOfferElementItem', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('calculateProcessOfferElementItem', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('calculateProcessOfferElementItem', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferElementId' is not null or undefined
            assertParamExists('calculateProcessOfferElementItem', 'processOfferElementId', processOfferElementId)
            // verify required parameter 'processOfferElementItemId' is not null or undefined
            assertParamExists('calculateProcessOfferElementItem', 'processOfferElementItemId', processOfferElementItemId)
            // verify required parameter 'processOfferElementItemCalculationRequestDto' is not null or undefined
            assertParamExists('calculateProcessOfferElementItem', 'processOfferElementItemCalculationRequestDto', processOfferElementItemCalculationRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/elements/{processOfferElementId}/items/{processOfferElementItemId}/recalculate`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferElementId}', encodeURIComponent(String(processOfferElementId)))
                .replace('{processOfferElementItemId}', encodeURIComponent(String(processOfferElementItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processOfferElementItemCalculationRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete process offer element
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessOfferElement: async (userId: string, processId: string, processOfferId: string, processOfferElementId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteProcessOfferElement', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('deleteProcessOfferElement', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('deleteProcessOfferElement', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferElementId' is not null or undefined
            assertParamExists('deleteProcessOfferElement', 'processOfferElementId', processOfferElementId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/elements/{processOfferElementId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferElementId}', encodeURIComponent(String(processOfferElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {number} processOfferElementItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessOfferElementItem: async (userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteProcessOfferElementItem', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('deleteProcessOfferElementItem', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('deleteProcessOfferElementItem', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferElementId' is not null or undefined
            assertParamExists('deleteProcessOfferElementItem', 'processOfferElementId', processOfferElementId)
            // verify required parameter 'processOfferElementItemId' is not null or undefined
            assertParamExists('deleteProcessOfferElementItem', 'processOfferElementItemId', processOfferElementItemId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/elements/{processOfferElementId}/items/{processOfferElementItemId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferElementId}', encodeURIComponent(String(processOfferElementId)))
                .replace('{processOfferElementItemId}', encodeURIComponent(String(processOfferElementItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get process offer element
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferElement: async (userId: string, processId: string, processOfferId: string, processOfferElementId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getProcessOfferElement', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessOfferElement', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('getProcessOfferElement', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferElementId' is not null or undefined
            assertParamExists('getProcessOfferElement', 'processOfferElementId', processOfferElementId)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/elements/{processOfferElementId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferElementId}', encodeURIComponent(String(processOfferElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zapisuje wyjaśnienie, dlaczego oferta świadomie nie zawiera składowej danego typu (transport, obsługa, sprzęt, dekoracje). Lista kontrolna przestaje wtedy ostrzegać, a w ofercie zostaje ślad: powód, autor i data. Puste `reason` cofa decyzję.  Kontener składowej powstaje w razie potrzeby — wyjaśnienie przychodzi zwykle, zanim ktokolwiek dodał cokolwiek tego typu. 
         * @summary skip an offer element type with a reason
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {SkipProcessOfferElementRequestDto} skipProcessOfferElementRequestDto Skip an offer element type with a reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipProcessOfferElement: async (userId: string, processId: string, processOfferId: string, skipProcessOfferElementRequestDto: SkipProcessOfferElementRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('skipProcessOfferElement', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('skipProcessOfferElement', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('skipProcessOfferElement', 'processOfferId', processOfferId)
            // verify required parameter 'skipProcessOfferElementRequestDto' is not null or undefined
            assertParamExists('skipProcessOfferElement', 'skipProcessOfferElementRequestDto', skipProcessOfferElementRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/elements/skip`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(skipProcessOfferElementRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update process offer element comment
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {UpdateProcessOfferElementCommentRequestDto} updateProcessOfferElementCommentRequestDto Update process offer element comment request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferElementComment: async (userId: string, processId: string, processOfferId: string, processOfferElementId: number, updateProcessOfferElementCommentRequestDto: UpdateProcessOfferElementCommentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferElementComment', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferElementComment', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferElementComment', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferElementId' is not null or undefined
            assertParamExists('updateProcessOfferElementComment', 'processOfferElementId', processOfferElementId)
            // verify required parameter 'updateProcessOfferElementCommentRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferElementComment', 'updateProcessOfferElementCommentRequestDto', updateProcessOfferElementCommentRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/elements/{processOfferElementId}/comment`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferElementId}', encodeURIComponent(String(processOfferElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessOfferElementCommentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {number} processOfferElementItemId 
         * @param {UpdateProcessOfferElementItemRequestDto} updateProcessOfferElementItemRequestDto Update process offer element item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferElementItem: async (userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, updateProcessOfferElementItemRequestDto: UpdateProcessOfferElementItemRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferElementItem', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferElementItem', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferElementItem', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferElementId' is not null or undefined
            assertParamExists('updateProcessOfferElementItem', 'processOfferElementId', processOfferElementId)
            // verify required parameter 'processOfferElementItemId' is not null or undefined
            assertParamExists('updateProcessOfferElementItem', 'processOfferElementItemId', processOfferElementItemId)
            // verify required parameter 'updateProcessOfferElementItemRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferElementItem', 'updateProcessOfferElementItemRequestDto', updateProcessOfferElementItemRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/elements/{processOfferElementId}/items/{processOfferElementItemId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferElementId}', encodeURIComponent(String(processOfferElementId)))
                .replace('{processOfferElementItemId}', encodeURIComponent(String(processOfferElementItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessOfferElementItemRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update process offer element predefined items
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {UpdateProcessOfferElementPredefinedItemsRequestDto} updateProcessOfferElementPredefinedItemsRequestDto Update process offer element predefined items request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferElementPredefinedItems: async (userId: string, processId: string, processOfferId: string, processOfferElementId: number, updateProcessOfferElementPredefinedItemsRequestDto: UpdateProcessOfferElementPredefinedItemsRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateProcessOfferElementPredefinedItems', 'userId', userId)
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessOfferElementPredefinedItems', 'processId', processId)
            // verify required parameter 'processOfferId' is not null or undefined
            assertParamExists('updateProcessOfferElementPredefinedItems', 'processOfferId', processOfferId)
            // verify required parameter 'processOfferElementId' is not null or undefined
            assertParamExists('updateProcessOfferElementPredefinedItems', 'processOfferElementId', processOfferElementId)
            // verify required parameter 'updateProcessOfferElementPredefinedItemsRequestDto' is not null or undefined
            assertParamExists('updateProcessOfferElementPredefinedItems', 'updateProcessOfferElementPredefinedItemsRequestDto', updateProcessOfferElementPredefinedItemsRequestDto)
            const localVarPath = `/api/processes/{processId}/offers/{processOfferId}/elements/{processOfferElementId}/items/update`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{processOfferId}', encodeURIComponent(String(processOfferId)))
                .replace('{processOfferElementId}', encodeURIComponent(String(processOfferElementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessOfferElementPredefinedItemsRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestProcessOfferElementsApi - functional programming interface
 */
export const RestProcessOfferElementsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestProcessOfferElementsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary add process offer element
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {AddProcessOfferElementRequestDto} addProcessOfferElementRequestDto Add process offer element request
         * @param {number} [processOfferGroupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProcessOfferElement(userId: string, processId: string, processOfferId: string, addProcessOfferElementRequestDto: AddProcessOfferElementRequestDto, processOfferGroupId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferElementIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProcessOfferElement(userId, processId, processOfferId, addProcessOfferElementRequestDto, processOfferGroupId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferElementsApi.addProcessOfferElement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary add process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {AddProcessOfferElementItemRequestDto} addProcessOfferElementItemRequestDto Add process offer element item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, addProcessOfferElementItemRequestDto: AddProcessOfferElementItemRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferElementItemIdDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, addProcessOfferElementItemRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferElementsApi.addProcessOfferElementItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary calculate process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {number} processOfferElementItemId 
         * @param {ProcessOfferElementItemCalculationRequestDto} processOfferElementItemCalculationRequestDto Process offer element item calculation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calculateProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, processOfferElementItemCalculationRequestDto: ProcessOfferElementItemCalculationRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferElementItemCalculationResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calculateProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, processOfferElementItemId, processOfferElementItemCalculationRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferElementsApi.calculateProcessOfferElementItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete process offer element
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProcessOfferElement(userId: string, processId: string, processOfferId: string, processOfferElementId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProcessOfferElement(userId, processId, processOfferId, processOfferElementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferElementsApi.deleteProcessOfferElement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {number} processOfferElementItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, processOfferElementItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferElementsApi.deleteProcessOfferElementItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get process offer element
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessOfferElement(userId: string, processId: string, processOfferId: string, processOfferElementId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessOfferElementDetailsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessOfferElement(userId, processId, processOfferId, processOfferElementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferElementsApi.getProcessOfferElement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zapisuje wyjaśnienie, dlaczego oferta świadomie nie zawiera składowej danego typu (transport, obsługa, sprzęt, dekoracje). Lista kontrolna przestaje wtedy ostrzegać, a w ofercie zostaje ślad: powód, autor i data. Puste `reason` cofa decyzję.  Kontener składowej powstaje w razie potrzeby — wyjaśnienie przychodzi zwykle, zanim ktokolwiek dodał cokolwiek tego typu. 
         * @summary skip an offer element type with a reason
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {SkipProcessOfferElementRequestDto} skipProcessOfferElementRequestDto Skip an offer element type with a reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async skipProcessOfferElement(userId: string, processId: string, processOfferId: string, skipProcessOfferElementRequestDto: SkipProcessOfferElementRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.skipProcessOfferElement(userId, processId, processOfferId, skipProcessOfferElementRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferElementsApi.skipProcessOfferElement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update process offer element comment
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {UpdateProcessOfferElementCommentRequestDto} updateProcessOfferElementCommentRequestDto Update process offer element comment request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferElementComment(userId: string, processId: string, processOfferId: string, processOfferElementId: number, updateProcessOfferElementCommentRequestDto: UpdateProcessOfferElementCommentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferElementComment(userId, processId, processOfferId, processOfferElementId, updateProcessOfferElementCommentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferElementsApi.updateProcessOfferElementComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {number} processOfferElementItemId 
         * @param {UpdateProcessOfferElementItemRequestDto} updateProcessOfferElementItemRequestDto Update process offer element item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, updateProcessOfferElementItemRequestDto: UpdateProcessOfferElementItemRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, processOfferElementItemId, updateProcessOfferElementItemRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferElementsApi.updateProcessOfferElementItem']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update process offer element predefined items
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {UpdateProcessOfferElementPredefinedItemsRequestDto} updateProcessOfferElementPredefinedItemsRequestDto Update process offer element predefined items request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessOfferElementPredefinedItems(userId: string, processId: string, processOfferId: string, processOfferElementId: number, updateProcessOfferElementPredefinedItemsRequestDto: UpdateProcessOfferElementPredefinedItemsRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessOfferElementPredefinedItems(userId, processId, processOfferId, processOfferElementId, updateProcessOfferElementPredefinedItemsRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessOfferElementsApi.updateProcessOfferElementPredefinedItems']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestProcessOfferElementsApi - factory interface
 */
export const RestProcessOfferElementsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestProcessOfferElementsApiFp(configuration)
    return {
        /**
         * 
         * @summary add process offer element
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {AddProcessOfferElementRequestDto} addProcessOfferElementRequestDto Add process offer element request
         * @param {number} [processOfferGroupId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProcessOfferElement(userId: string, processId: string, processOfferId: string, addProcessOfferElementRequestDto: AddProcessOfferElementRequestDto, processOfferGroupId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferElementIdDto> {
            return localVarFp.addProcessOfferElement(userId, processId, processOfferId, addProcessOfferElementRequestDto, processOfferGroupId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary add process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {AddProcessOfferElementItemRequestDto} addProcessOfferElementItemRequestDto Add process offer element item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, addProcessOfferElementItemRequestDto: AddProcessOfferElementItemRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferElementItemIdDto> {
            return localVarFp.addProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, addProcessOfferElementItemRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary calculate process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {number} processOfferElementItemId 
         * @param {ProcessOfferElementItemCalculationRequestDto} processOfferElementItemCalculationRequestDto Process offer element item calculation request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calculateProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, processOfferElementItemCalculationRequestDto: ProcessOfferElementItemCalculationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferElementItemCalculationResultDto> {
            return localVarFp.calculateProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, processOfferElementItemId, processOfferElementItemCalculationRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete process offer element
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessOfferElement(userId: string, processId: string, processOfferId: string, processOfferElementId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProcessOfferElement(userId, processId, processOfferId, processOfferElementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {number} processOfferElementItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, processOfferElementItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get process offer element
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessOfferElement(userId: string, processId: string, processOfferId: string, processOfferElementId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferElementDetailsDto> {
            return localVarFp.getProcessOfferElement(userId, processId, processOfferId, processOfferElementId, options).then((request) => request(axios, basePath));
        },
        /**
         * Zapisuje wyjaśnienie, dlaczego oferta świadomie nie zawiera składowej danego typu (transport, obsługa, sprzęt, dekoracje). Lista kontrolna przestaje wtedy ostrzegać, a w ofercie zostaje ślad: powód, autor i data. Puste `reason` cofa decyzję.  Kontener składowej powstaje w razie potrzeby — wyjaśnienie przychodzi zwykle, zanim ktokolwiek dodał cokolwiek tego typu. 
         * @summary skip an offer element type with a reason
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {SkipProcessOfferElementRequestDto} skipProcessOfferElementRequestDto Skip an offer element type with a reason
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        skipProcessOfferElement(userId: string, processId: string, processOfferId: string, skipProcessOfferElementRequestDto: SkipProcessOfferElementRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.skipProcessOfferElement(userId, processId, processOfferId, skipProcessOfferElementRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update process offer element comment
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {UpdateProcessOfferElementCommentRequestDto} updateProcessOfferElementCommentRequestDto Update process offer element comment request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferElementComment(userId: string, processId: string, processOfferId: string, processOfferElementId: number, updateProcessOfferElementCommentRequestDto: UpdateProcessOfferElementCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferElementComment(userId, processId, processOfferId, processOfferElementId, updateProcessOfferElementCommentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update process offer element item
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {number} processOfferElementItemId 
         * @param {UpdateProcessOfferElementItemRequestDto} updateProcessOfferElementItemRequestDto Update process offer element item request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, updateProcessOfferElementItemRequestDto: UpdateProcessOfferElementItemRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, processOfferElementItemId, updateProcessOfferElementItemRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update process offer element predefined items
         * @param {string} userId 
         * @param {string} processId 
         * @param {string} processOfferId 
         * @param {number} processOfferElementId 
         * @param {UpdateProcessOfferElementPredefinedItemsRequestDto} updateProcessOfferElementPredefinedItemsRequestDto Update process offer element predefined items request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessOfferElementPredefinedItems(userId: string, processId: string, processOfferId: string, processOfferElementId: number, updateProcessOfferElementPredefinedItemsRequestDto: UpdateProcessOfferElementPredefinedItemsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessOfferElementPredefinedItems(userId, processId, processOfferId, processOfferElementId, updateProcessOfferElementPredefinedItemsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestProcessOfferElementsApi - interface
 */
export interface RestProcessOfferElementsApiInterface {
    /**
     * 
     * @summary add process offer element
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {AddProcessOfferElementRequestDto} addProcessOfferElementRequestDto Add process offer element request
     * @param {number} [processOfferGroupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addProcessOfferElement(userId: string, processId: string, processOfferId: string, addProcessOfferElementRequestDto: AddProcessOfferElementRequestDto, processOfferGroupId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferElementIdDto>;

    /**
     * 
     * @summary add process offer element item
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {AddProcessOfferElementItemRequestDto} addProcessOfferElementItemRequestDto Add process offer element item request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    addProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, addProcessOfferElementItemRequestDto: AddProcessOfferElementItemRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferElementItemIdDto>;

    /**
     * 
     * @summary calculate process offer element item
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {number} processOfferElementItemId 
     * @param {ProcessOfferElementItemCalculationRequestDto} processOfferElementItemCalculationRequestDto Process offer element item calculation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    calculateProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, processOfferElementItemCalculationRequestDto: ProcessOfferElementItemCalculationRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferElementItemCalculationResultDto>;

    /**
     * 
     * @summary delete process offer element
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcessOfferElement(userId: string, processId: string, processOfferId: string, processOfferElementId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary delete process offer element item
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {number} processOfferElementItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary get process offer element
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessOfferElement(userId: string, processId: string, processOfferId: string, processOfferElementId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProcessOfferElementDetailsDto>;

    /**
     * Zapisuje wyjaśnienie, dlaczego oferta świadomie nie zawiera składowej danego typu (transport, obsługa, sprzęt, dekoracje). Lista kontrolna przestaje wtedy ostrzegać, a w ofercie zostaje ślad: powód, autor i data. Puste `reason` cofa decyzję.  Kontener składowej powstaje w razie potrzeby — wyjaśnienie przychodzi zwykle, zanim ktokolwiek dodał cokolwiek tego typu. 
     * @summary skip an offer element type with a reason
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {SkipProcessOfferElementRequestDto} skipProcessOfferElementRequestDto Skip an offer element type with a reason
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    skipProcessOfferElement(userId: string, processId: string, processOfferId: string, skipProcessOfferElementRequestDto: SkipProcessOfferElementRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary update process offer element comment
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {UpdateProcessOfferElementCommentRequestDto} updateProcessOfferElementCommentRequestDto Update process offer element comment request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferElementComment(userId: string, processId: string, processOfferId: string, processOfferElementId: number, updateProcessOfferElementCommentRequestDto: UpdateProcessOfferElementCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary update process offer element item
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {number} processOfferElementItemId 
     * @param {UpdateProcessOfferElementItemRequestDto} updateProcessOfferElementItemRequestDto Update process offer element item request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, updateProcessOfferElementItemRequestDto: UpdateProcessOfferElementItemRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary update process offer element predefined items
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {UpdateProcessOfferElementPredefinedItemsRequestDto} updateProcessOfferElementPredefinedItemsRequestDto Update process offer element predefined items request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessOfferElementPredefinedItems(userId: string, processId: string, processOfferId: string, processOfferElementId: number, updateProcessOfferElementPredefinedItemsRequestDto: UpdateProcessOfferElementPredefinedItemsRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestProcessOfferElementsApi - object-oriented interface
 */
export class RestProcessOfferElementsApi extends BaseAPI implements RestProcessOfferElementsApiInterface {
    /**
     * 
     * @summary add process offer element
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {AddProcessOfferElementRequestDto} addProcessOfferElementRequestDto Add process offer element request
     * @param {number} [processOfferGroupId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addProcessOfferElement(userId: string, processId: string, processOfferId: string, addProcessOfferElementRequestDto: AddProcessOfferElementRequestDto, processOfferGroupId?: number, options?: RawAxiosRequestConfig) {
        return RestProcessOfferElementsApiFp(this.configuration).addProcessOfferElement(userId, processId, processOfferId, addProcessOfferElementRequestDto, processOfferGroupId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary add process offer element item
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {AddProcessOfferElementItemRequestDto} addProcessOfferElementItemRequestDto Add process offer element item request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, addProcessOfferElementItemRequestDto: AddProcessOfferElementItemRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOfferElementsApiFp(this.configuration).addProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, addProcessOfferElementItemRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary calculate process offer element item
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {number} processOfferElementItemId 
     * @param {ProcessOfferElementItemCalculationRequestDto} processOfferElementItemCalculationRequestDto Process offer element item calculation request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public calculateProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, processOfferElementItemCalculationRequestDto: ProcessOfferElementItemCalculationRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOfferElementsApiFp(this.configuration).calculateProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, processOfferElementItemId, processOfferElementItemCalculationRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete process offer element
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProcessOfferElement(userId: string, processId: string, processOfferId: string, processOfferElementId: number, options?: RawAxiosRequestConfig) {
        return RestProcessOfferElementsApiFp(this.configuration).deleteProcessOfferElement(userId, processId, processOfferId, processOfferElementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete process offer element item
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {number} processOfferElementItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, options?: RawAxiosRequestConfig) {
        return RestProcessOfferElementsApiFp(this.configuration).deleteProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, processOfferElementItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get process offer element
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessOfferElement(userId: string, processId: string, processOfferId: string, processOfferElementId: number, options?: RawAxiosRequestConfig) {
        return RestProcessOfferElementsApiFp(this.configuration).getProcessOfferElement(userId, processId, processOfferId, processOfferElementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zapisuje wyjaśnienie, dlaczego oferta świadomie nie zawiera składowej danego typu (transport, obsługa, sprzęt, dekoracje). Lista kontrolna przestaje wtedy ostrzegać, a w ofercie zostaje ślad: powód, autor i data. Puste `reason` cofa decyzję.  Kontener składowej powstaje w razie potrzeby — wyjaśnienie przychodzi zwykle, zanim ktokolwiek dodał cokolwiek tego typu. 
     * @summary skip an offer element type with a reason
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {SkipProcessOfferElementRequestDto} skipProcessOfferElementRequestDto Skip an offer element type with a reason
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public skipProcessOfferElement(userId: string, processId: string, processOfferId: string, skipProcessOfferElementRequestDto: SkipProcessOfferElementRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOfferElementsApiFp(this.configuration).skipProcessOfferElement(userId, processId, processOfferId, skipProcessOfferElementRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update process offer element comment
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {UpdateProcessOfferElementCommentRequestDto} updateProcessOfferElementCommentRequestDto Update process offer element comment request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferElementComment(userId: string, processId: string, processOfferId: string, processOfferElementId: number, updateProcessOfferElementCommentRequestDto: UpdateProcessOfferElementCommentRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOfferElementsApiFp(this.configuration).updateProcessOfferElementComment(userId, processId, processOfferId, processOfferElementId, updateProcessOfferElementCommentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update process offer element item
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {number} processOfferElementItemId 
     * @param {UpdateProcessOfferElementItemRequestDto} updateProcessOfferElementItemRequestDto Update process offer element item request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferElementItem(userId: string, processId: string, processOfferId: string, processOfferElementId: number, processOfferElementItemId: number, updateProcessOfferElementItemRequestDto: UpdateProcessOfferElementItemRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOfferElementsApiFp(this.configuration).updateProcessOfferElementItem(userId, processId, processOfferId, processOfferElementId, processOfferElementItemId, updateProcessOfferElementItemRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update process offer element predefined items
     * @param {string} userId 
     * @param {string} processId 
     * @param {string} processOfferId 
     * @param {number} processOfferElementId 
     * @param {UpdateProcessOfferElementPredefinedItemsRequestDto} updateProcessOfferElementPredefinedItemsRequestDto Update process offer element predefined items request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessOfferElementPredefinedItems(userId: string, processId: string, processOfferId: string, processOfferElementId: number, updateProcessOfferElementPredefinedItemsRequestDto: UpdateProcessOfferElementPredefinedItemsRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessOfferElementsApiFp(this.configuration).updateProcessOfferElementPredefinedItems(userId, processId, processOfferId, processOfferElementId, updateProcessOfferElementPredefinedItemsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

